<template>
    <div ref="chart"></div>
  </template>
  
  <script >
  import * as d3 from 'd3';
  export default {
    name: 'BarChart',
    props: {
      data: {
        type: Array,
        required: true
      },
      width:{
        type: Number,
        default:500
      },
      height:{
        type: Number,
        default:300
      },
      maxElements:{
        type: Number,
        default:100
      },
      hideAxisX:{
        type:Boolean,
        default:false
      }
    },
    mounted() {
      this.createChart();
    },
    watch:{
      data(){
        this.updateChart()
        return
      }
    },
    methods: {
      createChart() {
        const data = this.data;
        const margin = { top: 20, right: 30, bottom: 40, left: 60 }
        const width = this.width - margin.left - margin.right
        const uniqueNames = new Set(data.map(obj => obj.name));
        const heightAxisY = this.height*(uniqueNames.size);
        const heightSVG = this.height*this.maxElements;

        this.svg = d3.select(this.$refs.chart)
          .append('svg')
          .attr('class', 'svg-main')
          .attr("viewBox", `0 0 ${width + margin.left + margin.right} ${heightSVG + margin.top + margin.bottom}`)
          //.attr('width', width + margin.left + margin.right)
          //.attr('height', height + margin.top + margin.bottom)
          .append('g')
          .attr('transform', `translate(${margin.left},${0})`);
        this.y = d3.scaleBand()
          .domain(data.map(d => d.name))
          .range([heightAxisY, 0])
          .padding(0.1);
        this.x = d3.scaleLinear()
          .domain([0,24])
          .nice()
          .range([0, width]);

        this.svg.append('g')
          .selectAll('.bar')
          .data(data)
          .enter().append('rect')
          .attr('class', 'bar')
          .attr('y', d => this.y(d.name))
          .attr('x', d => this.x(d.value[0]))
          .attr('height', this.height-1)
          .attr('width', d => this.x(d.value[1]-d.value[0]))
          .attr('fill', 'steelblue')
          
        if(!this.hideAxisX){
          this.svg.append('g')
          .attr('class', 'x-axis')
          .call(d3.axisTop(this.x)
          .ticks(30));
        }
        

        this.svg.append('g')
          .attr('class', 'y-axis')
          .call(d3.axisLeft(this.y))
      },
      updateChart() {
        const data = this.data;
        const uniqueNames = new Set(data.map(obj => obj.name));
        const heightAxisY = this.height*(uniqueNames.size);

        // Actualizar la escala Y con los nuevos datos
        this.x.domain([0, 24])
        this.y.domain(data.map(d => d.name))
          .range([heightAxisY, 0])

        this.svg.select('.y-axis')
            .transition()
            .duration(750)
            .call(d3.axisLeft(this.y)) 


        // Seleccionar todas las barras y enlazar los nuevos datos
        const bars = this.svg.selectAll('.bar')
            .data(data)


        // Actualizar las barras existentes
        bars.transition().duration(750)
          .attr('x', d => this.x(d.value[0]))
          .attr('y', d => this.y(d.name))
          .attr('width', d => this.x(d.value[1]-d.value[0]))
          
            
        bars.enter()
          .append('rect')
          .attr('class', 'bar')
          .attr('y', d => this.y(d.name))
          .attr('x', this.x(0))
          .attr('height', this.height-1)
          .attr('width', 0)
          .attr('fill', 'steelblue')
          .transition().duration(750)
          .attr('x', d => this.x(d.value[0]))
          .attr('width', d => this.x(d.value[1]-d.value[0]))

        bars.exit()
          .transition().duration(750)
          .attr("x", this.x(0)) // Animación hacia el eje X
          .attr("width", 0) // Animación hacia altura 0
          .remove(); // Remover del DOM después de la animación

      }
    }
  };
  </script>
  <style scoped>
  .bar {
    fill: steelblue;
  }
  .x-axis path,
  .x-axis line,
  .y-axis path,
  .y-axis line {
    shape-rendering: crispEdges;
  }
  .x-axis path{
    position: fixed;
  }
  .x-axis text,
  .y-axis text {
    text-anchor: end;
    font-size: 12px;
  }
  </style>